import styled from "styled-components";
import { ReactComponent as Logo } from 'assets/img/logo.svg';

export const AppLogo = ({orientation = 'horisontal', excludeText=false, size = 'md', align='center'}) => {

    return (
        <StyledAppLogo
            title="v. 0.00.004 build 22260528"
            href="/dashboard"
            $orientation={orientation} $size={size} $align={align}
        >
            <Logo/>
            {
                !excludeText ? <span><span>InfraHub</span> Workspace</span> : null
            }
        </StyledAppLogo>
    )
}

const StyledAppLogo = styled.a`

    display: flex;
    cursor: pointer;
    justify-content: ${({$align}) => $align};
    align-items: center;
    flex-direction: ${({$orientation}) => $orientation === 'vertical'  ? 'column' : 'row'};
    gap: 10px;
    text-decoration: none;
    color: ${({theme}) => theme.colors.neutralPrimaryForeground};

    svg
    {
        height: ${({$size}) => $size === 'lg' ? '64px' : $size==='md' ? '32px' : '24px'};
        width: ${({$size}) => $size === 'lg' ? '64px' : $size==='md' ? '32px' : '24px'};
    }

    > span
    {
        > span
        {
            font-weight: 700;    
        }

        font-weight: 400;
        font-size: ${({$size, theme}) => $size === 'lg' ? theme.fontSize.xl : theme.fontSize.md};
    }
`